import React, {useEffect, useState} from "react";
import {observer} from "mobx-react";
import styled from "styled-components";
import {
    Breadcrumb,
    Button,
    Col,
    Collapse,
    DatePicker,
    Form,
    Image,
    Layout,
    List,
    Modal,
    Pagination,
    Row,
    Space,
    Table,
    Tabs,
    TabsProps
} from "antd";
import {Content} from "antd/es/layout/layout";
import {useNavigate} from "react-router-dom";
import Input from "antd/es/input/Input";
import {useStore} from "../../store";
import {ColumnsType} from "antd/lib/table";
import {SpecimenEntity} from "../../entity/specimen-entity";
import {TableDisplayEnum} from "../../entity/enum/home";
import PlantDetail from "../detail/plant-detail";
import {showFullScreenLoading, tryHideFullScreenLoading} from "../../config/serviceLoading";
import {getSpecimenListApi} from "../../http/manager";
import {DownOutlined, RedoOutlined, SearchOutlined, UpOutlined} from "@ant-design/icons";
import "../../css/global.css"
import {getThumbImageUrl} from "../../utils/imageUtil";
import {getSpecimenList} from "../../http/home";

const defaultIcon = require("../../image/default-pic.png")

const SearchPage:React.FC  = () => {

    const navigateTo = useNavigate();
    const [form] = Form.useForm();
    const store = useStore();
    const {searchStore}  = store;
    const [type, setType] = useState("1")
    useEffect(()=> {
        firstQuery();
        return clear;
    }, [])
    const toHomeSearch = () => {
        navigateTo("/home/search", {replace: true});
    }
    const onRadioChange = (e: string) => {
        searchStore.setDisplayType(e);
    }
    const onExpendClick = () => {
        const fields = form.getFieldsValue;
        const isExpend = searchStore.isExpend;
        searchStore.setExpend(!isExpend);
        form.setFieldsValue(fields);
    }

    const clear = () => {
        searchStore.clear();
    }

    const tabItems:TabsProps['items'] = [
        {
            key: "1",
            label: "标本记录",
        },
        {
            key: "2",
            label: "原植物图库",
        },
        {
            key: "3",
            label: "图谱库",
        },
        {
            key: "4",
            label: "DNA序列库",
        },
        {
            key: "5",
            label: "科普宣传",
        },
    ];

    const columns: ColumnsType<SpecimenEntity> = [
        {
            title: '序号',
            width: 70,
            dataIndex: 'id',
            key: 'id',
            align: "center",
            render: (value, record, index) => {
                return <div>{Number(index)+1}</div>
            }
        },
        {
            title: '种中文名',
            width: 200,
            dataIndex: 'specimenName',
            key: 'specimenName',
            // fixed: 'left',
            align: "center"

        },
        {
            title: '种拉丁名',
            width: 300,
            dataIndex: 'specimenCanonicalName',
            key: 'specimenCanonicalName',
            // fixed: 'left',
            align: "center"
        },
        {
            title: '采集人',
            width: 150,
            dataIndex: 'gatherer',
            key: 'gatherer',
            align: "center"
            // fixed: 'left',
        },
        {
            title: '采集号',
            width: 150,
            dataIndex: 'gatherNumber',
            key: 'gatherNumber',
            align: "center"
            // fixed: 'left',
        },
        {
            title: '采集日期',
            width: 150,
            dataIndex: 'gatherDate',
            key: 'gatherDate',
            align: "center"
            // fixed: 'left',
        },
        {
            title: '省市',
            width: 150,
            dataIndex: 'province',
            key: 'province',
            align: "center"
            // fixed: 'left',
        },
        {
            title: '区县',
            width: 150,
            dataIndex: 'district',
            key: 'district',
            align: "center"
            // fixed: 'left',
        },
    ];

    const ListTypeTabs = [
        {key: "list", label: "列表展示"},
        {key: "image", label: "卡片展示"},
    ]

    const onTabChange = (key: string) => {
        setType(key);
        onQuery();
    }

    const onLibraryChange = (e:any) => {
        searchStore.condition.libraryCode = e.target.value;
    }

    const onNameChange = (e:any) => {
        searchStore.condition.specimenName = e.target.value;
    }

    const onLatingChange = (e:any) => {
        searchStore.condition.specimenCanonicalName = e.target.value;
    }

    const onProvinceChange = (e:any) => {
        searchStore.condition.province = e.target.value;
    }
    const onDistrictChange = (e:any) => {
        searchStore.condition.district = e.target.value;
    }
    const onAuthChange = (e:any) => {
        searchStore.condition.authenticateEr = e.target.value;
    }
    const onAreaChange = (e:any) => {
        searchStore.condition.province = e.target.value;
        searchStore.condition.district = e.target.value;
    }

    const onPersonChange = (e:any) => {
        searchStore.condition.gatherer = e.target.value;
        searchStore.condition.gatherNumber = e.target.value;
    }

    const onDateChange = (values: any, formatString: [string, string]) => {
        searchStore.condition.gatherDateStart = formatString[0];
        searchStore.condition.gatherDateEnd = formatString[1];
    }

    const renderItem = (item: any) => {
        return <List.Item style={{minWidth: "400px"}}>
            <CardWrapper onClick={() => {onItemClick(item)}}>
                <div style={{display:"flex", flexDirection: "row", padding: "5px 20px 10px 5px"}}>
                    <Image style={{width:"100px", height:"100px", margin:"15px 20px 10px 15px"}} src={getThumbImageUrl(item.imgUrl)} fallback={defaultIcon} preview={false}/>
                    <CardContent>
                        <span>{item.specimenName}</span>
                        <span>{`馆藏条码号:${item.libraryCode}`}</span>
                        <span>{`采集人：${item.gatherer}`}</span>
                        <span>{`采集地点：${item.province}${item.district}`}</span>
                        <span>{`采集时间：${item.gatherDate}`}</span>
                    </CardContent>
                </div>
            </CardWrapper>
        </List.Item>
    }

    const onItemClick = (item: any) => {
        searchStore.setPlantDetail(item);
        searchStore.setDetailModalOpen(true);
    }

    const onSizeChange = (page:any, pageSize:any) => {
        searchStore.pagination.pageSize = pageSize;
        searchStore.pagination.pageNum = page;
        onQuery();
    }

    const onClose = () => {
        searchStore.setDetailModalOpen(false);
    }

    const firstQuery = () => {
        const params = {
            libraryCode: form.getFieldValue("libraryCode"),
            specimenName: form.getFieldValue("specimenName"),
            gatherer: form.getFieldValue("gatherer"),
            // gatherDateEnd: moment(form.getFieldValue("gatherDate")[1]).format("YYYY-MM-DD"),
            // gatherDateStart: moment(form.getFieldValue("gatherDate")[0]).format("YYYY-MM-DD"),
            gatherNumber: form.getFieldValue("gatherNumber"),
            province: form.getFieldValue("province"),
            district: form.getFieldValue("district"),
            authenticateEr: form.getFieldValue("authenticateEr"),
            pageNum: searchStore.pagination.pageNum,
            pageSize: searchStore.pagination.pageSize,
            type: type,
            // searchKey: searchStore.searchKey ? searchStore.searchKey : "",
        }
        showFullScreenLoading()
        queryClassifyList(params);
        searchStore.setSearchKey("");
    }


    const onRest = () => {
        searchStore.resetQuery();
        form.setFieldsValue(searchStore.condition)
        onQuery();
    }

    const onQuery = () => {
        let gatherDateStart = "";
        let gatherDateEnd = "";
        if (form.getFieldValue("gatherDate") && form.getFieldValue("gatherDate").length > 1) {
            gatherDateStart = form.getFieldValue("gatherDate")[0].format("YYYY-MM-DD");
            gatherDateEnd = form.getFieldValue("gatherDate")[1].format("YYYY-MM-DD");
        }
        const params = {
            libraryCode: form.getFieldValue("libraryCode"),
            specimenName: form.getFieldValue("specimenName"),
            gatherer: form.getFieldValue("gatherer"),
            gatherDateEnd: gatherDateEnd,
            gatherDateStart: gatherDateStart,
            gatherNumber: form.getFieldValue("gatherNumber"),
            province: form.getFieldValue("province"),
            district: form.getFieldValue("district"),
            authenticateEr: form.getFieldValue("authenticateEr"),
            specimenCanonicalName: form.getFieldValue("specimenCanonicalName"),
            pageNum: searchStore.pagination.pageNum,
            pageSize: searchStore.pagination.pageSize,
        }
        showFullScreenLoading()
        queryClassifyList(params);
    }

    const queryClassifyList = (params: any) => {
        getSpecimenList(params)
            .then((res) => {
                tryHideFullScreenLoading();
                searchStore.pagination.total = res.data ? res.data.total : 0;
                refreshTableData((res.data && res.data.list && res.data.list.length > 0) ? res.data.list : []);
            }).catch(() => {
            tryHideFullScreenLoading();
        })
    }

    const refreshTableData = (data:SpecimenEntity[]) => {
        const list:SpecimenEntity[] = [];
        data.forEach((item) => {
            item.key = String(item.id);
            list.push(item);
        })
        searchStore.setDataSource(list);
    }

    const FirstLevelSearch = () => {
        return (<Form form={form} labelAlign={"right"} style={{maxWidth:"none", padding:"5px"}} wrapperCol={{span:"15"}}><Row>
            <Col span={5} offset={1}><Form.Item name={"specimenName"} labelCol={{span:"7"}}  label={"种中文名"}><Input onChange={onNameChange}/></Form.Item></Col>
            <Col span={5} offset={1}><Form.Item name={"specimenCanonicalName"} labelCol={{span:"7"}} label={"种拉丁名"}><Input onChange={onLatingChange}/></Form.Item></Col>
            <Col span={10}><Form.Item name={["gatherDate"]} wrapperCol={{span:"9"}} labelCol={{span:"7"}} label={"采集日期"}><DatePicker.RangePicker format={"YYYY-MM-DD"}/></Form.Item></Col>
            <Col span={2}><Button onClick={onExpendClick} icon={searchStore.isExpend ? <UpOutlined /> : <DownOutlined />} type={"link"}>{searchStore.isExpend ? "折叠" : "展开"}</Button></Col>
        </Row></Form>)
    }

    const SecondLevelSearch = () => {
        return (<Form form={form} labelAlign={"right"} style={{maxWidth:"none"}} wrapperCol={{span:"15"}}><Row>
            <Col span={5} offset={1}><Form.Item name={"province"} labelCol={{span:"7"}} label={"省市"}>
                <Input/></Form.Item></Col>
            <Col span={5} offset={1}><Form.Item name={"district"} labelCol={{span:"7"}} label={"区县 "}><Input
            /></Form.Item></Col>
            <Col span={10} ><Form.Item name={"authenticateEr"} wrapperCol={{span:"9"}} labelCol={{span:"7"}} label={"鉴定人 "}><Input
                /></Form.Item></Col>
            <Col span={2}><div/></Col>
        </Row></Form>)
    }

    return (
        <Wrapper>
            <Layout style={{padding: "0"}}>
                <Content style={{background:"#f5f5f5", padding: "20px"}}>
                    <SearchWrapper>
                        <SearchTitleWrapper>
                            <Breadcrumb style={{background:"white", padding: "5px 0"}}>
                                <Breadcrumb.Item href={""} onClick={toHomeSearch}>首页</Breadcrumb.Item>
                                <Breadcrumb.Item><span style={{color: "black"}}>高级搜索</span></Breadcrumb.Item>
                            </Breadcrumb>
                            <Space className={"searchButton"} size={"small"} align={"start"} direction={"horizontal"}>
                                {true && <Button icon={<SearchOutlined />} onClick={onQuery} type={"primary"}>查询</Button>}
                                <Button icon={<RedoOutlined />} onClick={onRest} ghost={true} type={"primary"}>重置</Button>
                            </Space>
                        </SearchTitleWrapper>
                        <Line/>
                        <Collapse
                            activeKey={searchStore.isExpend ? ['1'] : ["0"]}
                            defaultActiveKey={['0']} ghost>
                            <Collapse.Panel  collapsible={"icon"} showArrow={false} key={1} header={<FirstLevelSearch/>}>
                                <SecondLevelSearch/>
                            </Collapse.Panel>
                        </Collapse>
                    </SearchWrapper>
                    {/* <Row gutter={40} style={{padding: "10px 0"}}>
                        <Col span={8}><Form.Item style={{marginBottom: "10px"}}  label={"馆藏条码"}><Input onChange={onLibraryChange} value={searchStore.condition.libraryCode}/></Form.Item></Col>
                        <Col span={8}><Form.Item style={{marginBottom: "10px"}}  label={"中文名/学名"}><Input onChange={onNameChange} value={searchStore.condition.specimenName}/></Form.Item></Col>
                        {searchStore.isExpend && <Col span={8}><Form.Item style={{marginBottom: "10px"}}  label={"采集日期"}><DatePicker.RangePicker format={"YYYY-MM-DD"}  onChange={onDateChange}/></Form.Item></Col>}
                        {searchStore.isExpend && <Col span={8}><Form.Item style={{marginBottom: "10px"}}  label={"采集地"}><Input value={searchStore.condition.province} onChange={onAreaChange}/></Form.Item></Col>}
                        {searchStore.isExpend && <Col span={8}><Form.Item style={{marginBottom: "10px"}}  label={"采集人/采集号"}><Input value={searchStore.condition.gatherer} onChange={onPersonChange}/></Form.Item></Col>}
                        <Col span={8}> <Radio.Group defaultValue={"list"} buttonStyle={"solid"} onChange={onRadioChange}>
                            <Radio.Button value={"list"}>列表展示</Radio.Button>
                            <Radio.Button value={"image"}>卡片展示</Radio.Button>
                        </Radio.Group></Col>
                        <Col  span={8}><Button onClick={onRest} type={"default"}>重置</Button>
                        <Button onClick={onQuery} style={{marginLeft: "30px"}} type={"primary"}>查询</Button>
                        <ToggleWrapper onClick={onExpendClick}>{!searchStore.isExpend ? "展开" : "关闭"}</ToggleWrapper></Col>
                    </Row> */}

                    <ContentWrapper>
                        <Tabs onChange={onRadioChange} defaultActiveKey={"list"} type={"card"} size={"small"} items={ListTypeTabs}/>
                        {searchStore.displayType === TableDisplayEnum.List && (type === "1" || type === "2") && <Table
                            style={{margin:"0 20px 20px 20px"}}
                            bordered={true}
                            size={"small"}
                            rowClassName={ (type,index, intent) => {
                                return index%2 === 0 ? "tableItemWhite" : "tableItemGray";
                            }}
                            columns={columns}
                            dataSource={searchStore.dataSource}
                            onRow={(record) => {
                                return {
                                    onClick:() =>  onItemClick(record),
                                }
                            }}
                            scroll={{x: 1000, y:450}}
                            pagination={{position: [], pageSize: searchStore.pagination.pageSize}}
                        />}
                        {searchStore.displayType === TableDisplayEnum.Card && (type === "1" || type === "2") && <div
                            style={{margin:"0 79px", height:"450px" , marginBottom: "30px", overflow: "scroll"}}>
                            <List
                                grid={{
                                    gutter: 16,
                                    column: 3
                                }} dataSource={searchStore.dataSource} renderItem={renderItem}/>
                        </div>}
                        <Pagination
                            size={"small"}
                            style={{margin: "20px 20px 20px 0", alignSelf: "end"}}
                            total={searchStore.pagination.total}
                            showQuickJumper={true}
                            showSizeChanger={true}
                            defaultPageSize={10}
                            current={searchStore.pagination.pageNum}
                            hideOnSinglePage={true}
                            onChange={onSizeChange}
                        />
                    </ContentWrapper>
                </Content>
            </Layout>
            <Modal
                open={searchStore.detailModalOpen}
                onCancel={onClose}
                closable={true}
                centered={true}
                destroyOnClose={true}
                title={null}
                footer={null}
                mask={true}
                maskClosable={true}
                width={"1000px"}>
                <PlantDetail detail={searchStore.plantDetail}/>
            </Modal>
        </Wrapper>
    );
}

export default observer(SearchPage);
const Wrapper = styled.div`
  & {
    display: flex;
    flex-direction: column;
    flex: 1;
    background: #EDEFEF;
    overflow: hidden;
    .ant-list {
      overflow-x: hidden;
    }
    .ant-form-item {
      margin-bottom: 0px;
    }

    .tableItemWhite{
      background: white;
    }
    .tableItemGray{
      background: #F9FAFD;
    }
    
    .ant-layout-content {
        overflow: hidden;
        display: flex;
        background: white;
        flex-direction: column;
        justify-content: flex-start;
    }

    .ant-table-wrapper {
        flex: 1;
        overflow: hidden;
    }

    .ant-spin-nested-loading,
    .ant-spin-container,
    .ant-table {
        height: 100%;
    }

    .ant-table-container {
        height: 100%;
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }

    .ant-table-content table {
        height: 100%;
        overflow: hidden;
    }

    .ant-table-body {
        flex: 1 !important;
    }
  }
`;
const SearchWrapper = styled.div`
  & {
    border-radius: 4px;
    border: 1px solid #EAEDF7;
    background: white;
    display: flex;
    flex-direction: column;
    padding-bottom: 10px;
  }
`;
const SearchTitleWrapper = styled.div`
  & {
    display: flex;
    justify-content: space-between;
    margin: 15px 20px 13px 20px;
    .searchTitle{
      font-size: 16px;
      font-family: SourceHanSansCN-Medium, SourceHanSansCN;
      font-weight: 500;
      color: #000000;
      line-height: 32px;
      flex: 1;
    }
  }
`;

const Line = styled.div`
  & {
    height: 0.5px;
    border: 1px solid #EAEDF7;
  }
`;
const ContentWrapper = styled.div`
  & {
    flex: 1;
    margin-top: 20px;
    border-radius: 4px;
    border: 1px solid #EAEDF7;
    background: white;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
`;
const ToggleWrapper = styled.span`
  & {
    font-size: 14px;
    line-height: 32px;
    color: #1677ff;
    text-align: center;
    padding: 0 10px;
  }
`;

const CardWrapper = styled.div`
  & {
    display: flex;
    flex-direction: column;
    background: white;
    border: 1px solid #E8EBF2;
    border-radius: 2px;
  }
`;
const CardContent = styled.span`
  & {
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    color: #666666;
    span:nth-child(1) {
      font-size: 16px;
      line-height: 24px;
      font-weight: 500;
      color: black;
      margin-bottom: 10px;
    }
  }
`;